/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { DeleteAllNotificationsParams } from "../types/deleteAllNotificationsParams";

import type { DeleteNotificationsRequestDto } from "../types/deleteNotificationsRequestDto";

import type { DeleteNotificationsResultDto } from "../types/deleteNotificationsResultDto";

import type { ListNotificationsParams } from "../types/listNotificationsParams";

import type { MarkNotificationsReadResultDto } from "../types/markNotificationsReadResultDto";

import type { MarkNotificationsRequestDto } from "../types/markNotificationsRequestDto";

import type { NotificationCountsDto } from "../types/notificationCountsDto";

import type { NotificationDto } from "../types/notificationDto";

import type { NotificationDtoPaginatedResult } from "../types/notificationDtoPaginatedResult";

import type { ProblemDetails } from "../types/problemDetails";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const listNotifications = (
  params?: ListNotificationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<NotificationDtoPaginatedResult>> => {
  return axios.default.get(`/api/notifications`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListNotificationsQueryKey = (
  params?: ListNotificationsParams,
) => {
  return [`/api/notifications`, ...(params ? [params] : [])] as const;
};

export const getListNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = AxiosError<unknown>,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNotifications>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListNotificationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNotifications>>
  > = ({ signal }) => listNotifications(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotifications>>
>;
export type ListNotificationsQueryError = AxiosError<unknown>;

export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = AxiosError<unknown>,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNotifications>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getNotificationCounts = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<NotificationCountsDto>> => {
  return axios.default.get(`/api/notifications/counts`, options);
};

export const getGetNotificationCountsQueryKey = () => {
  return [`/api/notifications/counts`] as const;
};

export const getGetNotificationCountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationCounts>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationCounts>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationCountsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotificationCounts>>
  > = ({ signal }) => getNotificationCounts({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationCounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationCountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationCounts>>
>;
export type GetNotificationCountsQueryError = AxiosError<unknown>;

export function useGetNotificationCounts<
  TData = Awaited<ReturnType<typeof getNotificationCounts>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationCounts>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationCountsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const markNotificationRead = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<NotificationDto>> => {
  return axios.default.post(
    `/api/notifications/${id}/mark-read`,
    undefined,
    options,
  );
};

export const getMarkNotificationReadMutationOptions = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationRead>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationRead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["markNotificationRead"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationRead>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return markNotificationRead(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationRead>>
>;

export type MarkNotificationReadMutationError = AxiosError<ProblemDetails>;

export const useMarkNotificationRead = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationRead>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationRead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getMarkNotificationReadMutationOptions(options);

  return useMutation(mutationOptions);
};
export const markNotificationUnread = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<NotificationDto>> => {
  return axios.default.post(
    `/api/notifications/${id}/mark-unread`,
    undefined,
    options,
  );
};

export const getMarkNotificationUnreadMutationOptions = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationUnread>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationUnread>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["markNotificationUnread"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationUnread>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return markNotificationUnread(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationUnreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationUnread>>
>;

export type MarkNotificationUnreadMutationError = AxiosError<ProblemDetails>;

export const useMarkNotificationUnread = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationUnread>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationUnread>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getMarkNotificationUnreadMutationOptions(options);

  return useMutation(mutationOptions);
};
export const markNotificationsRead = (
  markNotificationsRequestDto: MarkNotificationsRequestDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MarkNotificationsReadResultDto>> => {
  return axios.default.post(
    `/api/notifications/mark-read`,
    markNotificationsRequestDto,
    options,
  );
};

export const getMarkNotificationsReadMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsRead>>,
    TError,
    { data: MarkNotificationsRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationsRead>>,
  TError,
  { data: MarkNotificationsRequestDto },
  TContext
> => {
  const mutationKey = ["markNotificationsRead"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationsRead>>,
    { data: MarkNotificationsRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return markNotificationsRead(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationsRead>>
>;
export type MarkNotificationsReadMutationBody = MarkNotificationsRequestDto;
export type MarkNotificationsReadMutationError = AxiosError<unknown>;

export const useMarkNotificationsRead = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsRead>>,
    TError,
    { data: MarkNotificationsRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationsRead>>,
  TError,
  { data: MarkNotificationsRequestDto },
  TContext
> => {
  const mutationOptions = getMarkNotificationsReadMutationOptions(options);

  return useMutation(mutationOptions);
};
export const markNotificationsUnread = (
  markNotificationsRequestDto: MarkNotificationsRequestDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MarkNotificationsReadResultDto>> => {
  return axios.default.post(
    `/api/notifications/mark-unread`,
    markNotificationsRequestDto,
    options,
  );
};

export const getMarkNotificationsUnreadMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsUnread>>,
    TError,
    { data: MarkNotificationsRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationsUnread>>,
  TError,
  { data: MarkNotificationsRequestDto },
  TContext
> => {
  const mutationKey = ["markNotificationsUnread"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationsUnread>>,
    { data: MarkNotificationsRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return markNotificationsUnread(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationsUnreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationsUnread>>
>;
export type MarkNotificationsUnreadMutationBody = MarkNotificationsRequestDto;
export type MarkNotificationsUnreadMutationError = AxiosError<unknown>;

export const useMarkNotificationsUnread = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsUnread>>,
    TError,
    { data: MarkNotificationsRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationsUnread>>,
  TError,
  { data: MarkNotificationsRequestDto },
  TContext
> => {
  const mutationOptions = getMarkNotificationsUnreadMutationOptions(options);

  return useMutation(mutationOptions);
};
export const markAllNotificationsRead = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MarkNotificationsReadResultDto>> => {
  return axios.default.post(
    `/api/notifications/mark-all-read`,
    undefined,
    options,
  );
};

export const getMarkAllNotificationsReadMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAllNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["markAllNotificationsRead"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    void
  > = () => {
    return markAllNotificationsRead(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAllNotificationsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAllNotificationsRead>>
>;

export type MarkAllNotificationsReadMutationError = AxiosError<unknown>;

export const useMarkAllNotificationsRead = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof markAllNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getMarkAllNotificationsReadMutationOptions(options);

  return useMutation(mutationOptions);
};
export const markAllNotificationsUnread = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MarkNotificationsReadResultDto>> => {
  return axios.default.post(
    `/api/notifications/mark-all-unread`,
    undefined,
    options,
  );
};

export const getMarkAllNotificationsUnreadMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsUnread>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAllNotificationsUnread>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["markAllNotificationsUnread"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAllNotificationsUnread>>,
    void
  > = () => {
    return markAllNotificationsUnread(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAllNotificationsUnreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAllNotificationsUnread>>
>;

export type MarkAllNotificationsUnreadMutationError = AxiosError<unknown>;

export const useMarkAllNotificationsUnread = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsUnread>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof markAllNotificationsUnread>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getMarkAllNotificationsUnreadMutationOptions(options);

  return useMutation(mutationOptions);
};
export const deleteNotifications = (
  deleteNotificationsRequestDto: DeleteNotificationsRequestDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteNotificationsResultDto>> => {
  return axios.default.post(
    `/api/notifications/delete`,
    deleteNotificationsRequestDto,
    options,
  );
};

export const getDeleteNotificationsMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNotifications>>,
    TError,
    { data: DeleteNotificationsRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNotifications>>,
  TError,
  { data: DeleteNotificationsRequestDto },
  TContext
> => {
  const mutationKey = ["deleteNotifications"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNotifications>>,
    { data: DeleteNotificationsRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return deleteNotifications(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNotificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNotifications>>
>;
export type DeleteNotificationsMutationBody = DeleteNotificationsRequestDto;
export type DeleteNotificationsMutationError = AxiosError<unknown>;

export const useDeleteNotifications = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNotifications>>,
    TError,
    { data: DeleteNotificationsRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteNotifications>>,
  TError,
  { data: DeleteNotificationsRequestDto },
  TContext
> => {
  const mutationOptions = getDeleteNotificationsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const deleteAllNotifications = (
  params?: DeleteAllNotificationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteNotificationsResultDto>> => {
  return axios.default.post(`/api/notifications/delete-all`, undefined, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getDeleteAllNotificationsMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAllNotifications>>,
    TError,
    { params?: DeleteAllNotificationsParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAllNotifications>>,
  TError,
  { params?: DeleteAllNotificationsParams },
  TContext
> => {
  const mutationKey = ["deleteAllNotifications"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAllNotifications>>,
    { params?: DeleteAllNotificationsParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteAllNotifications(params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAllNotificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAllNotifications>>
>;

export type DeleteAllNotificationsMutationError = AxiosError<unknown>;

export const useDeleteAllNotifications = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAllNotifications>>,
    TError,
    { params?: DeleteAllNotificationsParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAllNotifications>>,
  TError,
  { params?: DeleteAllNotificationsParams },
  TContext
> => {
  const mutationOptions = getDeleteAllNotificationsMutationOptions(options);

  return useMutation(mutationOptions);
};
